import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { companyFragment, viewerFragment, pageInfoFragment } from 'fragments'
import BusinessLayout from 'components/layouts/BusinessLayout'
import moment from 'moment'
import Pager from 'components/business/shared/Pager'
import { PAYMENT_METHOD } from 'modules/company'

function SummaryListContainer(props) {
  const STATUS = {
    PENDING: 0,
    REQUESTED: 1,
    PAID: 2,
  }
  const { company } = props.data
  const reservationSummaries = company.reservationSummaries
  const pageInfo = reservationSummaries.pageInfo

  function renderStatus(summary) {
    return null // 現在会社ごとの月ごと金額確定処理は存在しないため表示しない

    let className
    if (summary.status === STATUS.PENDING) {
      className = 'business-summary__box-status business__status-undecided'
    } else if (summary.status === STATUS.REQUESTED) {
      className = 'business-summary__box-status business__status-claim'
    } else if (summary.status === STATUS.PAID) {
      className = 'business-summary__box-status business__status-done'
    }

    return <p className={className}>{summary.statusText}</p>
  }

  function renderDueDate(summary) {
    return null // 現在会社ごとの月ごと金額確定処理は存在しないため表示しない

    let className
    const dueDate = moment([summary.year, summary.month])
    dueDate.add(1, 'months')

    if (summary.status === STATUS.REQUESTED) {
      className = 'business-summary__box-limit'
    } else {
      className = 'business-summary__box-limit-done'
    }
    return (
      <p className={className}>
        {i18n.t('page.paymentInformation.paymentDueDate')}
        {dueDate.format('YYYY年MM月')}月末
      </p>
    )
  }

  function renderSummaries() {
    const { variables } = props.data
    const summaries = reservationSummaries.results.map(summary => {
      const targetDate = moment([summary.year, summary.month - 1, 1])
      const prevDate = moment([summary.year, summary.month - 1, 1])
      targetDate.add(1, 'months').date(0)

      return (
        <div key={summary.id} className="business-summary__box">
          <a
            href={`/companies/${
              company.username
            }/reservations?startedAt=${prevDate.format(
              'YYYYMMDD',
            )}&endedAt=${targetDate.format('YYYYMMDD')}`}
          >
            <div className="business-summary__box-date">
              {renderStatus(summary)}
              <p className="business-summary__box-description">
                {prevDate.format('MM月DD日')}〜{targetDate.format('MM月DD日分')}
              </p>
              <p className="business-summary__box-month">
                {targetDate.format('YYYY年MM月')}
              </p>
            </div>
            <div className="business-summary__box-result">
              {renderDueDate(summary)}
              <div className="business-summary__box-result-reservation">
                <p className="business-summary__box-description">
                  {i18n.t('page.paymentInformation.totalReservations')}
                </p>
                <p className="business-summary__box-month">
                  {summary.reservationCount}
                </p>
              </div>
              <div className="business-summary__box-result-fee">
                <p className="business-summary__box-description">
                  {i18n.t('page.paymentInformation.totalFee')}
                </p>
                <p className="business-summary__box-month">
                  {summary.totalAmountText}
                </p>
              </div>
            </div>
          </a>
        </div>
      )
    })

    return summaries
  }

  return (
    <BusinessLayout
      title={i18n.t('server.business.paymentInformation.title')}
      description={i18n.t('server.business.paymentInformation.description')}
      {...props}
    >
      <div className="container">
        <h1 className="business__title">
          {i18n.t('page.paymentInformation.sectionTitle')}
        </h1>
        <p className="business-summary__select">
          {i18n.t('page.paymentInformation.paymentMethod')}：
          {company.paymentMethod === PAYMENT_METHOD.POSTPAY
            ? `${i18n.t('page.shared.l_00052')} (${company.paymentMethodText}）`
            : company.paymentMethodText}
          <a
            href={`/companies/${company.username}/setting`}
            className="business-summary__select-change"
          >
            {i18n.t('page.paymentInformation.chenge')}
          </a>
        </p>
        {renderSummaries()}
      </div>
      {pageInfo.totalPages > 1 && (
        <Pager
          variables={variables}
          pathName={'/'}
          pageInfo={pageInfo}
          windowSize={1}
        />
      )}
    </BusinessLayout>
  )
}

const withData = graphql(
  gql`
  query BusinessSummaryListContainer($username: String!, $page: Int!, $perPage: Int!) {
    company(username: $username) {
      ${companyFragment}
      paymentMethodText
      reservationSummaries(page: $page, perPage: $perPage) {
        results {
          ... on CompanyReservationSummary {
            id
            year
            month
            totalAmountText
            reservationCount
            status
            statusText
          }
        }
        pageInfo {
          ${pageInfoFragment}
        }
      }
    }
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        username: props.match.params.username,
        page: 1,
        perPage: 20,
      },
    }),
  },
)(SummaryListContainer)

function mapStateToProps(state) {
  return state
}
export default withRouter(connect(mapStateToProps)(withData))
